import BtnAddImg from './BtnAddImg'

export default BtnAddImg